/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * @file OnboardingGetStartedPanel.jsx
 * Get-started panel with onboarding action cards.
 * @author Anuja Gaikwad
 * @since 2.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import OnboardingActionCard from './OnboardingActionCard';
import { classes } from './styles/OnboardingSplashStyles';

const OnboardingGetStartedPanel = ({
  title,
  actionCards,
  onActionClick
}) => (
  <section className={classes.getStartedPanel}>
    <Typography
      component="h2"
      className={`${classes.panelTitle} ${classes.getStartedTitle}`}
    >
      {title}
    </Typography>

    <div className={classes.actionCardList}>
      {actionCards.map((card) => (
        <OnboardingActionCard
          key={card.id}
          actionId={card.id}
          title={card.title}
          description={card.description}
          iconName={card.iconName}
          badgeLabel={card.badgeLabel}
          onClick={onActionClick}
        />
      ))}
    </div>
  </section>
);

OnboardingGetStartedPanel.propTypes = {
  title: PropTypes.string.isRequired,
  actionCards: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    badgeLabel: PropTypes.string
  })).isRequired,
  onActionClick: PropTypes.func
};

OnboardingGetStartedPanel.defaultProps = {
  onActionClick: () => {}
};

export default OnboardingGetStartedPanel;
